import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import "./styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-page">

      <div className="privacy-container">

        <button
          className="privacy-back-btn"
          onClick={() => navigate("/")}
        >
          ← Back to Home
        </button>

        <div className="privacy-header">
          <span>LEGAL INFORMATION</span>

          <h1>Privacy Policy</h1>

          <p>
            Genesis Tech Engineers is committed to protecting the privacy,
            confidentiality, and security of customer and employee data
            processed through Genesis HRMS.
          </p>
        </div>

        <div className="privacy-content">

          

          <div className="privacy-section">
            <h2>How We Use Information</h2>

            <p>
              Information collected through the platform is used to deliver
              workforce management services, improve user experience,
              provide technical support, maintain system security, and
              comply with applicable legal and regulatory requirements.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Data Security</h2>

            <p>
              We implement industry-standard security controls, encryption
              practices, access restrictions, and monitoring procedures to
              protect information from unauthorized access, disclosure,
              alteration, or destruction.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Information Sharing</h2>

            <p>
              Genesis Tech Engineers does not sell, rent, or trade customer
              information. Data may only be shared with authorized service
              providers or where required by applicable law and regulatory
              authorities.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Data Retention</h2>

            <p>
              Information is retained only for as long as necessary to
              fulfill business, legal, contractual, and compliance
              obligations. Organizations retain ownership of their HRMS
              data at all times.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Cookies & Analytics</h2>

            <p>
              Our website and services may use cookies and analytics tools
              to improve performance, understand usage trends, and enhance
              user experience. No sensitive employee information is shared
              through these technologies.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Your Rights</h2>

            <p>
              Customers may request access, correction, or deletion of
              applicable personal information subject to contractual and
              legal obligations. Requests will be reviewed and processed
              in accordance with applicable regulations.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Contact Us</h2>

            <p>
              For privacy-related questions, concerns, or requests,
              please contact:
            </p>

            <p>
              <strong>Genesis Tech Engineers Pvt. Ltd.</strong><br />
              Email: contact@genesistech.co.in<br />
              Phone: +91 7841063605
            </p>
          </div>

        </div>

      </div>

      <Footer />

    </div>
  );
};

export default PrivacyPolicy;